import BaseError, { ErrorProps } from './BaseError';

export const DefaultError = (props: ErrorProps) => (
  <BaseError
    description="We are sorry for the inconvenience. Please try again later."
    title="Something Went Wrong"
    {...props} />
);
